import $ from 'jquery';
window.jQuery = window.$ = $;
console.log($('body'));

import '../../module/CmsBox/assets/js/concat/ajax.pw.core'
import '../../module/CmsBox/assets/js/concat/jquery.cookie'
import '../../module/CmsBox/assets/js/concat/pw.loader'
import '../../module/CmsBox/assets/js/concat/pw.affix'
import '../../module/CmsBox/assets/js/concat/pw.form'
import '../../module/CmsBox/assets/js/concat/pw.flashMessenger'
import '../../module/CmsBox/assets/js/concat/pw.dataTable'
import '../../module/CmsBox/assets/js/concat/pw.segmet'
import '../../module/CmsBox/assets/js/concat/pw.selection'





